import { styled } from "@mui/material";
import {
  FlexBox,
  type FlexBoxProps,
} from "@/components/baseComponents/FlexBox";
import { CONTENT_WIDTH } from "@/utils/styles.constants";

interface StyledContainerProps extends FlexBoxProps {
  variant?: "primary" | "secondary";
}

export const StyledContainer = styled((props: StyledContainerProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { variant, ...other } = props;
  return <FlexBox component="header" {...other} />;
})<{ variant?: "primary" | "secondary" }>(({ theme, variant = "primary" }) => ({
  padding: `0 max(calc((100% - ${CONTENT_WIDTH}) / 2), 20px)`,
  height: "72px",
  zIndex: theme.zIndex.appBar,
  alignItems: "center",
  justifyContent: "space-between",
  ...(variant === "primary" && {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  }),
  ...(variant === "secondary" && {
    backgroundColor: "transparent",
    color: theme.palette.primary.main,
  }),
}));
